<div class="vl-wrap">
  <h3 class="vl-heading" *ngIf="heading">{{ heading }}</h3>

  <div class="value-ladder" [style.--vl-thumb]="thumb">
    <!-- Two sliders, no boxes: pick a hue and a lightness. -->
    <div class="vl-controls">
      <div class="vl-control">
        <div class="vl-row">
          <label class="vl-label" for="vl-hue">Hue</label>
          <input id="vl-hue" class="vl-slider vl-hue-slider" type="range" min="0" max="359" step="1"
                 [value]="hue" (input)="onHue( $any( $event.target ).value )" aria-label="Hue">
        </div>
        <span class="vl-value">{{ hueLabel }}&deg;</span>
      </div>
      <div class="vl-control">
        <div class="vl-row">
          <label class="vl-label" for="vl-light">Lightness</label>
          <input id="vl-light" class="vl-slider vl-light-slider" type="range" min="0" max="100" step="1"
                 [value]="light" (input)="onLight( $any( $event.target ).value )" aria-label="Lightness">
        </div>
        <span class="vl-value">{{ lightLabel }}%</span>
      </div>
    </div>

    <!-- The color, and beside it the grey of its lightness. Drag the hue and the grey
         never moves; drag the lightness and both shift together. -->
    <div class="vl-results">
      <div class="vl-result">
        <div class="vl-swatch" [style.background]="colorHex"></div>
        <span class="vl-result-hex">{{ colorHex }}</span>
      </div>
      <div class="vl-result">
        <div class="vl-swatch" [style.background]="greyHex"></div>
        <span class="vl-result-hex">{{ greyHex }}</span>
      </div>
    </div>
  </div>
</div>
